import { Component } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { TemplateDtoFormGroup } from '../../../../../../libs/utils/ng-shared-components/src/lib/templates/dtos/TemplateDto';
import { TemplateEmailDtoFormGroup } from './dtos/TemplateEmailDto';
import { moduleName } from '../../../../ts-shared/src/lib/module-names';
import { enumName_templates } from './enums/_enumName.templates';

@Component({
  standalone: false,
  selector: 'mf-template-header-info-email',
  templateUrl: './template-header-info-email.component.html',
  styleUrls: ['./template-header-info-email.component.scss'],
})
export class TemplateHeaderInfoEmailComponent {
  constructor(private _formGroup: FormGroupDirective) {}

  templateForm: FormGroup<TemplateEmailDtoFormGroup>;

  enumName = enumName_templates;
  moduleName = moduleName;

  ngOnInit(): void {
    this.templateForm = this._formGroup.control as FormGroup<TemplateDtoFormGroup>;
  }
}
